module.exports = __webpack_public_path__ + "img/pro-data-management.4c988612.webp";